import { i18n } from '@runtime/core/i18n/i18n'

export function openPosterOrAlert() {
  if (window.openPoster) {
    window.openPoster()
    return
  }

  alert(i18n.t('common.posterUnavailableFile'))
}
